import SmsQueueItem from './SmsQueueItem';
import SmsQueueSearchPanel from './SmsQueueSearchPanel';
import EmptyList from '@/components/Common/EmptyList';
import { hDeepCopy }  from '@/utils/helpers';
import moment from 'moment';

// @vue/component
export default {
  name: 'SmsQueue',

  components: {
    SmsQueueItem,
    SmsQueueSearchPanel,
    EmptyList,
  },

  props: {
    contentSize: {
      type: String,
      default: 'smallTable',
    },
    projectsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedProject: '',
      currentPage: 1,
      itemsPerPage: 10,
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      filterBy: {
        project: '',
        number: '',
        status: '',
        date: null,
      },
      isSending: false,
      
    };
  },

  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    itemsPerPage: {
      handler() {
        this.currentPage = 1;
      }
    }
  },

  computed: {
    smsQueueList() {
      return this.$store.getters['sms/queueList'];
    },
    smsQueueFilteredList() {
      let filteredQueueList = hDeepCopy(this.smsQueueList.records)
      if (this.filterBy.number) {
        filteredQueueList = filteredQueueList.filter(item => item.dst.includes(this.filterBy.number));
      }
      if (this.filterBy.status) {
        filteredQueueList = filteredQueueList.filter(item => item.status === this.filterBy.status);
      }
      if (this.filterBy.date && this.filterBy.date.length > 0) {
        filteredQueueList = filteredQueueList.filter(item => moment(item.stamp).isBetween(this.filterBy.date[0], this.filterBy.date[1]));
      }
      if (this.filterBy.project) {
        filteredQueueList = filteredQueueList.filter(item => item.uuid_project === this.filterBy.project);
      }
      return filteredQueueList;
    },
    queueItemsToRenderPerPage() {
      return this.smsQueueFilteredList.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage)
    },
    statusList() {
      return this.$store.getters['sms/statusList'];
    },
    isEmpty() {
      return this.smsQueueList.total === 0;
    },
    isSinglePage() {
      return this.smsQueueFilteredList.length <= this.itemsPerPage;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/getSmsQueueList',
        'sms/sendAllSmsFromProject'
      ]);
    },
    isDisabled() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/getSmsQueueList',
        'sms/sendAllSmsFromProject',
        'sms/removeSmsFromQueue'
      ]);
    }
  },
  methods: {
    getSmsQueueList() {
      this.$store.dispatch('sms/getSmsQueueList');
    },
    async sendAllSmsFromProject() {
      this.isSending = true;
      const responseStatus = await this.$store.dispatch('sms/sendAllSmsFromProject', this.selectedProject);
      if (responseStatus === 200) {
        this.$message({
          type: 'success',
          message: "Sms'y zostały wysłane.",
        });
      } else {
        this.$message({
          type: 'error',
          message: "Wystąpił błąd podczas wysyłania SMS'ów",
        });
      }
      await this.$store.dispatch('sms/getSmsQueueList');
      this.isSending = false;
    },
    changeFilterBy(value) {
      this.filterBy = value
    },
    handleChangePage(page) {
      this.currentPage = page;
    },
  },
  created() {
    this.getSmsQueueList();
  }
};
